module.exports = __webpack_public_path__ + "img/lens-150-plus-05.98c9972b.png";